import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  ViewReport,
  ViewReportContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-view-report',
  template: ViewReport.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewReportComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = ViewReport.height;
  @Input() public viewBox: string = getSVGViewBox(ViewReport.viewBox);
  @Input() public width: number | string = ViewReport.width;
  @Input()
  public set context(ctx: ViewReportContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: ViewReportContext = ViewReport.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = ViewReportComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : ViewReport.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
